import { render, staticRenderFns } from "./GiftModal.vue?vue&type=template&id=6d75a52a&"
import script from "./GiftModal.vue?vue&type=script&lang=js&"
export * from "./GiftModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports